<template>
  <b-card
    class="conversation-activity"
    :class="{ dark: isDarkMode }"
  >
    <span
      class="conversation-activity--title mb-2 text-center"
      :class="{ dark: isDarkMode }"
    >
      Conversations
    </span>
    <div id="stackedColumnChart" ref="stackedColumnChart"></div>
  </b-card>
</template>

<script>
import ApexCharts from "apexcharts";
import moment from "moment";

let stackedColumnChart = null;
export default {
  name: "ConversationActivityGraph",
  props: {
    conversationActivityData: Array,
    isDarkMode: Boolean,
  },
  watch: {
    series(newValue, oldValue) {
      if (newValue !== oldValue) {
        stackedColumnChart.updateSeries(this.series);
        stackedColumnChart.updateOptions(this.options);
      }
    },
    conversationActivityData(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getFormattedData();
      }
    },
    isDarkMode(newVal, oldVal) {
      if (newVal !== oldVal) {
        stackedColumnChart.updateOptions({
          tooltip: {
            theme: newVal === true ? "dark" : "light",
          },
        });
      }
    },
  },
  data() {
    return {
      series: [],

      options: {
        chart: {
          type: "bar",
          height: "90%",
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },

        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "top",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            borderRadiusApplication: "end", // 'around', 'end'
            borderRadiusWhenStacked: "last", // 'all', 'last'
          },
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: "13px",
                fontWeight: 900,
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          position: "top",
          labels: {
            colors: "#989898",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          theme: this.isDarkMode ? "dark" : "light",
        },
      },
    };
  },
  mounted() {
    this.getFormattedData();
    this.renderChart();
  },

  methods: {
    updateChart() {
      stackedColumnChart.updateOptions({
        xaxis: {
          labels: {
            style: {
              colors: this.isDarkMode ? "#b2b9bf" : "#000",
              fontSize: "14px",
              opacity: 1,
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: this.isDarkMode ? "#b2b9bf" : "#000",
              fontSize: "14px",
              opacity: 1,
            },
          },
        },
      });
    },
    getFormattedData() {
      const inBoundData = [];
      const outBoundData = [];
      const monthData = [];
      if (
        this.conversationActivityData &&
        this.conversationActivityData.length > 0
      ) {
        this.conversationActivityData.map((value) => {
          inBoundData.push(value.inboundCount);
          outBoundData.push(value.outboundCount),
            monthData.push(moment(value.month).format("MMM YYYY"));
        });
      }
      this.series = [
        {
          name: "Inbound",
          data: [...inBoundData],
          color: "#36a2eb",
        },
        {
          name: "Outbound",
          data: [...outBoundData],
          color: "#ff9f40",
        },
      ];
      this.options = {
        ...this.options,
        series: this.series,
        xaxis: {
          categories: [...monthData],
        },
      };
    },

    renderChart() {
      stackedColumnChart = new ApexCharts(
        document.querySelector("#stackedColumnChart"),
        {
          ...this.options,
          series: [],
        }
      );
      stackedColumnChart.render();
    },
  },
  beforeDestroy() {
    if (stackedColumnChart) {
      stackedColumnChart.destroy();
    }
  },
};
</script>



<style lang="scss">
.conversation-activity {
  &.dark {
    .apexcharts-text tspan {
      fill: #b2b9bf;
    }
  }
  .apexcharts-text tspan {
    fill: #000;
  }
  &.card {
    height: 100%;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
    margin-bottom: 0;
  }
  &--title {
    font-size: 1.125rem;
    text-align: left;
    display: block;
    font-weight: 600;
    color: #333843;
    &.dark {
      color: #b2b9bf !important;
    }
  }

  #stackedColumnChart {
    height: 250px;
    @media (min-width: 1600px) {
      height: 300px !important;
    }
  }
}
</style>